import { createI18n } from 'vue-i18n'

import en from '../locales/en.json'
import fr from '../locales/fr.json'
import de from '../locales/de.json'
import it from '../locales/it.json'
import ja from '../locales/ja.json'
import pt from '../locales/pt.json'
import es from '../locales/es.json'
import he from '../locales/he.json'
import ko from '../locales/ko.json'
import ru from '../locales/ru.json'
import nl from '../locales/nl_NL.json'
import hi from '../locales/hi_IN.json'

export default defineNuxtPlugin((nuxtApp) => {
  const locale = getRequestLanguageCode()

  const i18n = createI18n({
    locale,
    fallbackLocale: 'en',
    globalInjection: true,
    legacy: false,
    messages: {
      ja,
      de,
      en,
      fr,
      it,
      pt,
      es,
      he,
      ko,
      ru,
      nl,
      hi
    }
  })

  nuxtApp.vueApp.use(i18n)
})
